/* @flow */

import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import CalendarRegularPen from './calendar-regular-pen-icon.svg';

function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <CalendarRegularPen {...validProps} />;
}
SvgComponent.iconName = 'calendar-regular-pen';

export const CalendarRegularPenIcon = svgIconWrapper(SvgComponent);
